module.exports = __webpack_public_path__ + "static/media/71s1LRpaprL._AC_SL1500_.8f1064ed.jpg";